module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d8bc2cc4dcc40abaa8b.worker.js");
};